<template>
	<div class="api-img" :id="currentID" @click="showModal()">
		<spinner v-if="isLoading" />
		<template v-else>
			<div class="b-img-container">
				<b-img class="b-img-holder" :src="transp" :alt="alt" />
				<b-img class="b-img-main" :src="computedUri" />
			</div>
		</template>
        <div class="widget" style="display: none;">
            <div class="md-dialog">
                <img style="max-width: 60vw;" :src="computedUri" />
            </div>
        </div>
	</div>
</template>

<script>
import _ from "lodash";
import transp from "@/assets/images/perfect-transparent.png";
import noPicture from "@/assets/images/no-picture.png";
import mobiscroll from "@mobiscroll/javascript";
import downloadPDF from "@/assets/images/pdf-download.png";
import axios from "axios";
export default {
	props: {
		comp: {
			type: [Number, String],
			required: false,
		},
		size: {
			type: String,
			default: null
		},
		allowPdf: {
			type: [String, Number, Boolean],
			default: false, // IF TRUE, IT WILL PRELOAD FROM ALMACENAMIENTO
			required: false,
		},
		alt: {
			type: [String],
			required: false,
		}
	},
	data: () => {
		return {
			currentID: null,
			isLoading: false,
			dataPreFetch: null,
			transp,
		};
	},
	computed: {
		isImg() {
			let allowedTypes = [".jpg", ".jpeg", ".png", ".bmp"];
			return (
				!this.allowPdf ||
				allowedTypes.indexOf(this.dataPreFetch.tipo) !== -1
			);
		},
		isVaultOpenable() {
			return this.allowPdf && !!this.dataPreFetch;
		},
		computedUri() {
			if (
				!this.allowPdf &&
				this.comp != null &&
				this.comp != "" &&
				typeof parseInt(this.comp) == "number"
			) {
				let uriName = (!!this.size) ? axios.defaults.maediaImageRender + this.comp + "/" + this.size + "/b-resized.jpg" : axios.defaults.maediaImageRender + this.comp + "/b-imgs.jpg";
				return uriName;
			} else if (!this.allowPdf || !this.isVaultOpenable) {
				return noPicture;
			} else if (!this.isImg) {
				return downloadPDF;
			} else {
				return this.dataPreFetch.url;
			}
		},
	},
	methods: {
		async preloadFromStorage() {
			this.isLoading = true;
			try {
				let response = await axios.get(
					"ui/storagepreread/" + this.comp
				);
				if (response.status) {
					this.dataPreFetch = response.data;
				}
			} catch (e) {}
			this.isLoading = false;
		},
		showModal() {
            if(this.isImg){
                let m = mobiscroll.widget("#" + this.currentID + " .widget", {
                    display: "center",
                    animate: "pop",
                    closeOnOverlayTap: true,
                    buttons: [
                        {
                            text: " Close",
                            handler: "cancel",
                        },
                    ],
                });
                m.show();
            } else if(this.isVaultOpenable) {
                window.open(this.dataPreFetch.url, '_blank')
            }
		},
	},
	async beforeMount() {
        this.currentID = _.uniqueId("api-img-");
		if (this.allowPdf && !!this.comp) {
			await this.preloadFromStorage();
		}
	},
};
</script>

<style lang="less">
.api-img {
	display: inline-block;
	text-align: center;
	width: 100%;

	.b-img {
		&-container {
			display: inline-block;
			position: relative;
			height: auto;
		}
		&-holder {
			display: inline-block;
			width: 100%;
		}
		&-main {
			position: absolute;
            z-index: 10;
            object-fit: cover;
            top: 0; left: 0; width: 100%; height: 100%;
			border-radius: 0.5em;
			overflow: hidden;
			border: 1px solid rgba(221, 221, 221, 0.478);
		}
	}

	&.rowed {
		.b-img {
			&-container {
				overflow: hidden;
				display: inline-block;
				width: 4em !important;
			}
		}
	}

	.widget {
		IMG {
			max-width: 60vw;
		}
	}
}
</style>


